import React from "react";

const Chevron = ({ className, style }) => (
  <svg
    viewBox="0 0 40 48"
    className={className}
    style={style}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M3.2 5.2 33.6 24 3.2 42.8V34L20.4 24 3.2 14Z" />
  </svg>
);

export default function UsaXSpinner({
  className = "",
  size = "h-9 w-7",
  label = "Loading",
}) {
  return (
    <div
      className={`flex items-center text-primary ${className}`}
      role="status"
      aria-label={label}
    >
      {[0, 1, 2].map((index) => (
        <Chevron
          key={index}
          className={`${size} animate-usax-chevron motion-reduce:animate-none motion-reduce:opacity-100`}
          style={{ animationDelay: `${index * 150}ms` }}
        />
      ))}
      <span className="sr-only">{label}</span>
    </div>
  );
}
